// Radix UI spacing tokens
// Based on Radix UI spacing system: https://www.radix-ui.com/themes/docs/theme/spacing
import { space as spaceTokens, containerSizes as containerTokens } from './tokens';

// Direct values for StyleX to use
export const space = {
    0: '0',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
    10: '40px',
    11: '44px',
    12: '48px',
    13: '52px',
    14: '56px',
    15: '60px',
    16: '64px',
    17: '68px',
    18: '72px',
    19: '76px',
    20: '80px',
};

// Values with CSS variables for runtime
export const spacing = {
    0: '0',
    1: 'var(--space-1, 4px)',
    2: 'var(--space-2, 8px)',
    3: 'var(--space-3, 12px)',
    4: 'var(--space-4, 16px)',
    5: 'var(--space-5, 20px)',
    6: 'var(--space-6, 24px)',
    7: 'var(--space-7, 28px)',
    8: 'var(--space-8, 32px)',
    9: 'var(--space-9, 36px)',
    10: 'var(--space-10, 40px)',
    11: 'var(--space-11, 44px)',
    12: 'var(--space-12, 48px)',
    13: 'var(--space-13, 52px)',
    14: 'var(--space-14, 56px)',
    15: 'var(--space-15, 60px)',
    16: 'var(--space-16, 64px)',
    17: 'var(--space-17, 68px)',
    18: 'var(--space-18, 72px)',
    19: 'var(--space-19, 76px)',
    20: 'var(--space-20, 80px)',
};

// Direct container values for StyleX
export const containerSizes = {
    1: '448px',
    2: '688px',
    3: '880px',
    4: '1136px',
    5: '1200px',
    6: '1400px',
};

// Container sizes with CSS variables for runtime
export const containers = {
    1: 'var(--container-1, 448px)',
    2: 'var(--container-2, 688px)',
    3: 'var(--container-3, 880px)',
    4: 'var(--container-4, 1136px)',
    5: 'var(--container-5, 1200px)',
    6: 'var(--container-6, 1400px)',
};

// Fluid responsive margin
export const responsiveMargin = {
    sm: {
        mobile: spacing[3],
        tablet: spacing[4],
        desktop: spacing[5],
    },
    md: {
        mobile: spacing[4],
        tablet: spacing[6],
        desktop: spacing[8],
    },
    lg: {
        mobile: spacing[6],
        tablet: spacing[8],
        desktop: spacing[10],
    },
    xl: {
        mobile: spacing[8],
        tablet: spacing[10],
        desktop: spacing[12],
    },
};

// Fluid responsive padding
export const responsivePadding = {
    sm: {
        mobile: spacing[3],
        tablet: spacing[4],
        desktop: spacing[5],
    },
    md: {
        mobile: spacing[4],
        tablet: spacing[6],
        desktop: spacing[8],
    },
    lg: {
        mobile: spacing[6],
        tablet: spacing[8],
        desktop: spacing[10],
    },
    xl: {
        mobile: spacing[8],
        tablet: spacing[10],
        desktop: spacing[12],
    },
};

// Gap values
export const gap = {
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
};

// CSS variable implementation for theming
export const initSpacingCssVars = () => {
    const root = document.documentElement;

    // Set spacing variables using token values
    Object.entries(spaceTokens).forEach(([key, value]) => {
        if (key !== '0') {
            root.style.setProperty(`--space-${key}`, value);
        }
    });

    // Set container variables using token values
    Object.entries(containerTokens).forEach(([key, value]) => {
        root.style.setProperty(`--container-${key}`, value);
    });
}; 